import { INodeStyleConfing } from "../../models/graph-kn.cm.nodes-model-const";
import { baseAccent, baseLight, basePrimary, baseSecondary } from "../graph-colors";

export const BP_Node_Style_Config:INodeStyleConfing = {
    textMain:{
        x:14,
        y:10,
        fontFamily:'Onest',
        fontSize:16,
        fill:basePrimary,
        verticalAlign: 'top',
        align: 'left',
    },
    fronLineWidth:5,
    statusPanel:{
        offsetX:0.03,
        offsetY:0.65,
        iconBackGround:baseSecondary,
        iconHeight:16,
        iconBackGroundHeight:34,
        toolTipBackGroundColor:baseLight,
        iconRadius:16,
        width:0.39,
        height:0.25,
        align:'left',
        gap:-6,
        tooltip:{
            fontFamily:'Onest',
            fontSize:15,
            fontColor:basePrimary,
            backGround:baseLight
        }
    },
    activeStep: {
        borderColor:baseAccent,
        borderWidth:4,
        edgeWidth:2
    },
    avatarPanel:{
        offsetX:8,
        offsetY:0.65,
        gapPanel:0,
        gapAvatar:-8,
        borderColor:baseLight,
        borderSize:4,
        avatarRadius:17,
        avatarHeight:34,
        toolTipBackGroundColor:baseLight,
        width:0.57,
        height:0.25,
        align:'right',
        genericAvatar: {
        fontFamily:'Onest',
        fontSize:15,
        fontColor:baseLight,
        },
        tooltip:{
            fontFamily:'Onest',
            fontSize:15,
            fontColor:basePrimary,
            backGround:baseLight
        }
    },
    edgeDeletButton: {
        iconPath:'../../../../assets/icons/graph/close-fill-accent.svg',
        iconRadius:6,
        iconHeight:14,
        iconBackGroundHeight:18,
        iconBackGroundColor:baseLight,
        activeIcon:true
    }
}